import 'react-app-polyfill/ie11'; import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import env from './config/environment';
import { setDefaultOptions } from 'esri-loader';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { LiveAnnouncer } from 'react-aria-live';
import App from './App';
//import * as serviceWorker from './serviceWorker';

let basename;
process.env.NODE_ENV !== 'production' ? (basename='') : (basename = "/tpt");

setDefaultOptions({ version: '4.19'});

if (process.env.NODE_ENV === 'production' && env.agsrestapi.indexOf("dev") === -1) {
  let sz = document.createElement('script');
  sz.type = 'text/javascript';
  sz.async = true;
  sz.src = '//siteimproveanalytics.com/js/siteanalyze_1585.js';
  let s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(sz, s);
}

ReactDOM.render(
  <Router basename={basename}>
    <LiveAnnouncer>
      <App />
    </LiveAnnouncer>
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();